import { theme } from '../constants/defaults';
import { formatMoney } from '../utils/product';

const lang = document.getElementsByTagName('html')[0].getAttribute('lang');

export const modalFooter = `
  <div class="ajaxcart__card">
    <div class="ajaxcart__card-title">
      <span>${theme.strings.cart_faq_title}</span>
    </div>
    <div class="rte">
      <ul>
        <li>
          <a href="/pages/contact">
            <svg class="icon icon-mail">
              <use xlink:href="#icon-mail"></use>
            </svg>
            <span>${theme.strings.cart_send_mail}</span>
          </a>
        </li>
        <li>
          <a href="/pages/faq">
            <svg class="icon icon-question">
              <use xlink:href="#icon-question"></use>
            </svg>
            <span>${theme.strings.cart_read_faq}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
`;

export function renderNote(note) {
  if (!theme.settings.cartNotes) {
    return '';
  }

  return `
    <div class="input-group">
      <label for="CartSpecialInstructions">${theme.strings.cart_note}</label>
      <textarea name="note" id="CartSpecialInstructions">${note || ''}</textarea>
    </div>
  `;
}

export function renderUpsell(state) {
  const upsellProducts = window.cartUpsell;

  if (upsellProducts.length > 0) {
    if (!theme.settings.cartUpsell) {
      return '';
    }

    const cartItemIds = state.items.map(item => item.product_id);

    let productSlides = '';

    upsellProducts.forEach(upsellProduct => {
      if (cartItemIds.indexOf(upsellProduct.id) === -1) {
        productSlides += `<div class="swiper-slide">
            <div class="ajaxcart__upsell">
              <div class="ajaxcart__upsell-product">
                <div class="product-item__visual">
                  <div class="visual visual--8x11 product-preview__visual">
                    <img src="${upsellProduct.featured_image}" alt="" loading="lazy">
                  </div>
                </div>

                <div class="ajaxcart__upsell-wrapper">
                  <p class="ajaxcart__product-info">
                    <a href="${lang === 'en' ? '' : `/${lang}`}/products/${
          upsellProduct.handle
        }" class="ajaxcart__product-name product-preview__title">
                      ${upsellProduct.title}
                    </a>
                  </p>
                  <div class="btn btn-mini text-center js-product-add-to-cart js-product-add-to-cart-upsell button--upsell button--full button--upsell-grid" data-value="${upsellProduct
                    .variants[0].price / 100}" data-quantity="1" data-variant-id="${
          upsellProduct.variants[0].id
        }">
                    <svg class="icon icon-cart">
                      <use xlink:href="#icon-cart"/>
                    </svg>
                    <span>€${upsellProduct.variants[0].price / 100}</span>
                  </div>

                </div>

              </div>
            </div>
          </div>`;
      }
    });

    return `
      <p class="h2 ajaxcart__upsell-title">${theme.strings.cart_upsell}</p>

      <div class="ajaxcart__slideshow-wrapper">
        <div class="slider slider__butcher slider--upsell__wrapper | js-slider" data-config="upsell-slider">
          <div class="swiper-container swiper-container-horizontal swiper-container-free-mode slider--upsell">
            <div class="swiper-wrapper">
  
            ${productSlides}
  
            </div>
          </div>
  
          <div class="ajaxcart__upsell-button ajaxcart__upsell-button--next slider__navigation-button | js-upsell-next">
            <svg class="icon icon-chevron-right">
              <use xlink:href="#icon-chevron-right"/>
            </svg>
          </div>
          <div class="ajaxcart__upsell-button ajaxcart__upsell-button--prev slider__navigation-button | js-upsell-prev">
            <svg class="icon icon-chevron-left">
              <use xlink:href="#icon-chevron-left"/>
            </svg>
          </div>
  
        </div>
      </div>
    `;
  }
  return '';
}

export function renderFooter(state) {
  const { total_price: totalPrice, total_discount: totalDiscount } = state;
  const priceRequired = 15000 - totalPrice;

  return `
    <div class="ajaxcart__footer">
      <div class="ajaxcart__subtotal">
        <div class="grid grid--gutter-0">
          <div class="grid__item two-thirds">
            <p><strong>${theme.strings.cart_subtotal}</strong></p>
          </div>
          <div class="grid__item one-third text-right">
            <p class="ajaxcart__total-price">${formatMoney(totalPrice)}</p>
          </div>
          ${
            totalDiscount
              ? `<p class="ajaxcart__savings text-center"> <em>${theme.strings.cart_savings.replace(
                  '[savings]',
                  formatMoney(totalDiscount),
                )}</em></p>`
              : ''
          }
        </div>
      </div>

      ${
        priceRequired > 0
          ? ` <div class="ajaxcart__promo | js-free-shipping-text">
      <p class="text-center mb0">
        ${theme.strings.cart_spend} <strong>${formatMoney(priceRequired)}</strong> ${
              theme.strings.cart_required
            }
      </p>
    </div>`
          : ` <div class="ajaxcart__promo | js-free-shipping-text">
          <p class="text-center mb0">
            ${theme.strings.cart_achieved}
          </p>
        </div>`
      }     

      <div class="ajax-cart__actions">
        <p class="mb10">
          <button type="submit" class="button button--full" name="checkout">
            ${theme.strings.cart_go_to_checkout}
          </button>
        </p>

        <p class="text-center mb1">
          <a href="#" class="js-modal-close">
            ${theme.strings.cart_continue_shopping}
          </a>
        </p>

      </div>

      ${priceRequired <= 3000 ? renderUpsell(state) : ''}

      ${modalFooter}
      
    </div>
  `;
}
